import { render } from "./AddBackup.vue?vue&type=template&id=54cac146&ts=true"
import script from "./AddBackup.ts?vue&type=script&lang=ts&external"
export * from "./AddBackup.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__